export const SET_ASSIGNMENTS = 'SET_ASSIGNMENTS';
export const SET_AVAILABLE_LOCATIONS = 'SET_AVAILABLE_LOCATIONS';
export const REMOVE_ASSIGNMENT = 'REMOVE_ASSIGNMENT';
export const CLEAR_ASSIGNMENTS = 'CLEAR_ASSIGNMENTS';
export const CLEAR_ASSIGNMENTS_SUCCESS = 'CLEAR_ASSIGNMENTS_SUCCESS';
